import url from 'url';
import { v4 as uuidv4 } from 'uuid';

export class ShopifyAuth {
  /**
   * @param {{ redirectUri: string; apiKey: string; accessMode?: string; scopes: string | string[]; }} options
   */
  constructor(options) {
    if (!options || !options.redirectUri || !options.apiKey) {
      throw new Error('Missing or invalid options');
    }

    this.accessMode = 'accessMode' in options ? options.accessMode : '';
    this.scopes = 'scopes' in options ? options.scopes : 'read_content';
    this.redirectUri = options.redirectUri;
    this.apiKey = options.apiKey;
  }

  /**
   * Generate a random nonce.
   *
   * @return {String} The random nonce
   * @public
   */
  generateNonce() {
    return uuidv4();
  }

  /**
   * Build the authorization URL.
   *
   * @param {String} shop The shop name
   * @param {String} [nonce] The nonce
   * @param {Array|String} [scopes] The list of scopes
   * @param {String} [accessMode] The API access mode
   * @return {String} The authorization URL
   * @public
   */
  generateAuthUrl(shop, nonce, scopes, accessMode) {
    scopes || (scopes = this.scopes);
    accessMode || (accessMode = this.accessMode);

    const query = {
      scope: Array.isArray(scopes) ? scopes.join(',') : scopes,
      state: nonce || this.generateNonce(),
      redirect_uri: this.redirectUri,
      client_id: this.apiKey,
    };

    if (accessMode) {
      query['grant_options[]'] = accessMode;
    }

    return url.format({
      pathname: '/admin/oauth/authorize',
      hostname: shop.endsWith('.myshopify.com')
        ? shop
        : `${shop}.myshopify.com`,
      protocol: 'https:',
      query,
    });
  }
}
